export const VERSION = '2026.39.00';